"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.text = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classes = _interopRequireWildcard(require("./classes"));
const _excluded = ["as", "className", "children", "emphasis", "size", "text"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Creates a function which represents a dynamic React component
 *
 * @param {String} TagName - The tag name of the element to use for text
 * @returns {Function} - A function to create a component
 */
function create(TagName) {
  /**
   * Creates a React component using the given tag name
   *
   * @param {Object} props - A props configuration object
   * @param {String} [props.as] - A category of text
   * @param {String} [props.className] - A class name to include
   * @param {Node} [props.children] - Deprecated, use text prop instead
   * @param {String} [props.emphasis] - Includes styles to represent feedback
   * @param {Number} [props.size] - A number representing the font size
   * @param {Node} [props.text] - The text content
   * @returns {React.Component} - A functional React component
   */
  function Text(_ref) {
    let {
        as,
        className,
        children,
        emphasis,
        size,
        text
      } = _ref,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    return /*#__PURE__*/_react.default.createElement(TagName, (0, _extends2.default)({
      className: (0, _classes.default)({
        as,
        className,
        emphasis,
        size
      })
    }, rest), children || text);
  }

  /**
   *
   * @enum {Object} expected types of properties.
   * @public
   */
  Text.propTypes = {
    /** The type of text expected in the component */
    as: _propTypes.default.oneOf(_classes.asOptions),
    /** children for the component, please use text prop instead */
    children: _propTypes.default.node,
    /** Classes to apply to component */
    className: _propTypes.default.string,
    /** The emphasis of text expected in the component */
    emphasis: _propTypes.default.oneOf(_classes.emphasisOptions),
    /** The size of the text, affected by the 'as' prop */
    size: _propTypes.default.number,
    /** Text to be displayed */
    text: _propTypes.default.node
  };
  return Text;
}
const text = exports.text = new Proxy(function () {}, {
  get: function get(target, prop) {
    // Deliberately not using hasOwnProperty to catch things like __proto__
    if (!String(prop).startsWith('_') && typeof target[prop] === 'undefined') {
      // Cache access by creating a key with value
      target[prop] = create(prop);
    }
    // Always return thing at that key, either undefined or thing set
    return Reflect.get(...arguments);
  }
});
var _default = exports.default = text;